export const LOAD_OFFICE = 'LOAD_OFFICE'

